import React from 'react';
import { getRatingColor } from '../../utils/colorUtils';
import './StarRating.scss';

interface Props {
  rating: number;
  onRate?: (r: number) => void;
  size?: number;
  readOnly?: boolean;
  color?: string;
}

const StarRating: React.FC<Props> = ({ rating, onRate, size = 10, readOnly = false, color }) => {
  const handleRate = (nextRating: number) => {
    if (readOnly || !onRate) return;
    onRate(rating === 1 && nextRating === 1 ? 0 : nextRating);
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map(i => (
        <button
          key={i}
          type="button"
          onClick={() => handleRate(i)}
          className={`star-rating__btn${readOnly ? ' star-rating__btn--readonly' : ''}`}
          aria-label={rating === i ? `Clear ${i} star rating` : `Set ${i} star rating`}
          aria-pressed={rating === i}
          disabled={readOnly}
        >
          <span
            className={`star-rating__circle${i <= rating ? ' star-rating__circle--active' : ''}`}
            style={{
              width: size,
              height: size,
              ...(i <= rating ? { '--sr-color': color || getRatingColor(rating) } as React.CSSProperties : {}),
            }}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
